import { useLocation } from "@solidjs/router";
import { type Component, createEffect } from "solid-js";
import { useReportGeneration } from "@/domains/company/report/context/report-generation-provider";

/**
 * Feeds the current route path to `ReportGenerationProvider`.
 *
 * The provider deliberately sits *above* the router so a generation survives
 * navigation — but router primitives like `useLocation()` only work *inside* a
 * `<Route>`, and calling one above it throws and takes the whole app down. This
 * component is the seam between those two requirements: mounted inside the
 * router, it pushes the path up to the provider, which needs it only to decide
 * between the dialog and the minimized indicator.
 *
 * Renders nothing.
 */
export const ReportGenerationRouteSync: Component = () => {
  const location = useLocation();
  const generation = useReportGeneration();

  createEffect(() => {
    generation.setCurrentPath(location.pathname);
  });

  return null;
};
